<template>
    <div>

    </div>
</template>


<script>
import {mapActions} from 'vuex'

export default {
    data() {
        return {
            // Code...
        }
    },
    created() {
        this.$root.$on('create-success', this.itemCreated)
        this.$root.$on('update-success', this.itemUpdated)
        this.$root.$on('delete-success', this.itemDeleted)
        this.$root.$on('error', this.error)
        this.$root.$on('task-copied', this.taskCopied);
    },
    methods: {
      ...mapActions('auth', ['logout']),

      error(e) {
          if (e.response && e.response.status && e.response.status === 401) {
            this.logout()
          }
          if (e.response && e.response.status && e.response.status !== 422) {
            let msg = "[" + e.response.status + "]" + " " + e.response.statusText
            msg = e.response.data && e.response.data.message ? e.response.data.message : msg
            this.$awn.alert(msg);
          }
        },
        itemCreated() {
            this.$awn.success('Your item has been successfully saved.')
        },
        itemUpdated() {
            this.$awn.success('Your item has been successfully updated.')
        },
        itemDeleted() {
            this.$awn.success('Your item has been successfully deleted.')
        },
        taskCopied(date) {
          this.$awn.success('Task copied to ' + date)
        }
    }
}
</script>


<style>

</style>



// WEBPACK FOOTER //
// src/components/partials/EventHub.vue